import React from 'react';
import { I18nManager } from 'react-native';
import Slider from 'react-slick';
import ViewPager from '@react-native-community/viewpager';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

type Props = React.ComponentProps<typeof ViewPager>;

const Component = React.forwardRef<Props, any>(
  ({ children, initialPage, onPageSelected }, ref) => {
    const sliderRef = React.useRef<Slider>(null);
    const newChildren = React.useMemo(() => React.Children.toArray(children), [
      children,
    ]);

    const handleAfterChange = React.useCallback(
      (currentSlide: number) => {
        onPageSelected?.(currentSlide);
      },
      [onPageSelected]
    );

    React.useImperativeHandle(
      ref,
      // @ts-ignore
      () => ({
        setPage: (page: number) => {
          sliderRef.current?.slickGoTo(page, false);
        },
        setPageWithoutAnimation: (page: number) => {
          sliderRef.current?.slickGoTo(page, true);
        },
      }),
      []
    );

    return (
      <Slider
        infinite={false}
        ref={sliderRef}
        initialSlide={
          I18nManager.isRTL && initialPage !== undefined
            ? newChildren.length - initialPage - 1
            : initialPage
        }
        slidesToScroll={1}
        slidesToShow={1}
        arrows={false}
        // lazyLoad="ondemand"
        rtl={I18nManager.isRTL}
        afterChange={handleAfterChange}
      >
        {children}
      </Slider>
    );
  }
);

Component.displayName = 'ViewPager';

export default Component;
